import users from '@/components/users/users/users';
import roles from '@/components/users/roles/roles';
import control from '@/components/users/control/Control';

export const users_and_roles = [
    {path: '/users', name: 'user', component: users},
    {path: '/roles', name: 'roles', component: roles},
    {path: '/control', name: 'control', component: control}
]